import React, {  useState } from "react";
import { Modal, Button } from 'antd';
import FormInput from "../../form-input/form-input.component";
import { connect } from "react-redux";
import { setAlert } from "../../../actions/alert";

import { addHomeWorkFile } from "../../../actions/homeWorks.actions";
import {PaperClipOutlined,FileImageOutlined} from "@ant-design/icons"

const AddFile = ({  exerciseID, addHomeWorkFile, setAlert  }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  



  const [file, setfile] = useState("");

  const onChangefile = (e) => {
    setfile(e.target.files[0]);
  };
  
  const onSubmit = async (e) => {
    e.preventDefault();

    if (file === "" ) {
      setAlert("ارجو إضافة ملف الاجابة ", "danger");
    } else {
      addHomeWorkFile(file, exerciseID);
      setAlert("تمت الإضافة بنجاح ", "success");
      setfile("");
    }
    setIsModalVisible(false);
  };

  return (
      <>
      <Button onClick={showModal} size="large">
         <PaperClipOutlined />
      </Button>
      <Modal title="تحميل ملف" visible={isModalVisible} 
      footer={[
        <Button key="back" onClick={handleCancel}>
          إلغاء الامر
        </Button>,
        <Button key="submit" type="primary"  onClick={onSubmit}>
          حفط
        </Button>,
      ]}
      >
            <label htmlFor="file"> ادخل الملف المراد تحميله</label>
            <br />
            <input id="file" type="file" onChange={onChangefile} />
      </Modal>
    </>
      
      
  );
};


export default connect(null, {
  addHomeWorkFile,
  setAlert,
})(AddFile);
